import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_OFFER1_75: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_OFFER1_75,
  },
  {
    pageId: PageId.CHAT_UPSELL_OFFER1_75,
  },
  {
    pageId: PageId.UPSELL_OFFER1_75,
  },
  {
    pageId: PageId.DOWNLOAD_OFFER1_75,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
